import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import './TauriBreadcrumbs.css';
import TauriFilter from './TauriFilter/TauriFilter';

const TauriBreadcrumbs = ({ parent, name, separator }) => {
    const [paths, setPaths] = useState([]);

    const loadBreadcrumbs = (parent, name) => {
        const matchingRoutes = findMatchingRoutes(parent, name);
        const extractedRoutes = extractRoutes(matchingRoutes);
        if (extractedRoutes[0]) {
            if (extractedRoutes[0].length == 1){
                setPaths(extractedRoutes[0]);
            } else {
                const remainingRoutes = extractedRoutes[0].slice(1);
                setPaths(remainingRoutes);
            }
        }
    }

    useEffect(() => {
        if (parent.id) {
            loadBreadcrumbs(parent, name)
        }
    }, [parent, name])

    const findMatchingRoutes = (json, name) => {
        const matchingRoutes = [];

        const traverse = (node, currentPath, route) => {
            if (node.name === currentPath) {
                matchingRoutes.push(route);
            }

            if (node.children) {
                for (const child of node.children) {
                    traverse(child, currentPath, [...route, child]);
                }
            }
        };

        traverse(json, name, [json]);
        return matchingRoutes;
    };

    const extractRoutes = (matchingRoutes) => {
        const extractedRoutes = [];
        for (const route of matchingRoutes) {
            const extractedRoute = [];
            for (const node of route) {
                extractedRoute.push({
                    id: node.id,
                    name: node.name,
                    icon: node.icon,
                    path: node.path,
                    roleLevel: node.roleLevel
                });
            }
            extractedRoutes.push(extractedRoute);
        }
        return extractedRoutes;
    };

    const handleOnclick = (clickName) => {
        if (parent.id) {
            loadBreadcrumbs(parent, clickName);
        }
    }

    return (
        <div className="breadcrumbs-container d-flex flex-column flex-xl-row justify-content-between align-items-start py-2 px-2 px-xl-4">
            <div className="left-component d-flex align-items-center">
                <Breadcrumb className="tauri-breadcrumbs d-none d-xl-block">
                    {paths.map((data, index) => (
                        <React.Fragment key={index}>
                            <Breadcrumb.Item active={index === paths.length - 1}>
                                {index === paths.length - 1 ? (
                                    <div className='item-breadcrumbs'>
                                        {data.icon && <img src={`${process.env.PUBLIC_URL}${data.icon}`} alt="Icon"/>}
                                        <span className='active-item text-dark'>{data.name}</span>
                                    </div>
                                ) : (
                                    <Link to={data.path} onClick={() => handleOnclick(data.path)} className='item-breadcrumbs'>
                                        {data.icon && <img src={`${process.env.PUBLIC_URL}${data.icon}`} alt="Icon"/>}
                                        {data.name}
                                    </Link>
                                )}
                            </Breadcrumb.Item>
                            {index < paths.length - 1 && (
                                <span className="separator">{separator}</span>
                            )}
                        </React.Fragment>
                    ))}
                </Breadcrumb>
            </div>
            <div className="right-component">
                <TauriFilter />
            </div>
        </div>
    );
};

export default TauriBreadcrumbs;
